// extracted by mini-css-extract-plugin
export default {"root":"IconReviewMountain_root__wyjTp","filled":"IconReviewMountain_filled__WaQWf"};